<div style="background-color: white;">
	<div class="modal-header">
		<h3>{{ visualiserMessages.supprimer_libelle | translate }}{{ idAvis }}</h3>
		<button (click)="activeModal.dismiss('close')" aria-label="Close" class="close" type="button">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		{{ visualiserMessages.descriptionA | translate }}{{ idAvis }}{{ visualiserMessages.descriptionB | translate }}
	</div>
	<div class="modal-footer">
		<button (click)="activeModal.dismiss('close')" class="btn btn-outline-primary mr-1" type="button">
			{{ visualiserMessages.annuler | translate }}
		</button>
		<button (click)="supprimerAvis()" class="btn btn-primary mr-1" type="button">
			{{ visualiserMessages.supprimer | translate }}
		</button>
	</div>
</div>